import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import LounasPage from "./pages/LounasPage";
import KahvilaPage from "./pages/KahvilaPage";
import PitopalveluPage from "./pages/PitopalveluPage";
import TarinaPage from "./pages/TarinaPage";
import YhteystiedotPage from "./pages/YhteystiedotPage";
import BuffetkoneePage from "./pages/BuffetkoneePage";
import JuhlaLaskuriLandingPage from "./pages/JuhlaLaskuriLandingPage";
import AdminPage from "./pages/AdminPage";
import DynamicCalculator from "./pages/DynamicCalculator";
import DemoOnlyPage from "./pages/DemoOnlyPage";
import { Toaster } from "./components/ui/sonner";

// Layout wrapper that conditionally shows Header/Footer
const AppLayout = ({ children }) => {
  const location = useLocation();
  // JuhlaLaskuri pages don't need Ravintola Data header/footer
  const hideLayout = location.pathname === '/' || 
                     location.pathname.startsWith('/admin') || 
                     location.pathname.startsWith('/laskuri') ||
                     location.pathname === '/demo';
  
  return (
    <>
      {!hideLayout && <Header />}
      <main>{children}</main>
      {!hideLayout && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppLayout>
          <Routes>
            {/* JuhlaLaskuri SaaS - Main pages */}
            <Route path="/" element={<JuhlaLaskuriLandingPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/laskuri/:slug" element={<DynamicCalculator />} />
            <Route path="/demo" element={<DemoOnlyPage />} />
          </Routes>
        </AppLayout>
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
